import { mapRemoteESGIndicatorToModel } from "src/app/core/valuation-process/_models/esg-indicator.model";
import { VLandAboutPropertyBase } from "../common";
import { VTPHouseModel } from "../house";
import { VTPLandModel } from "../land";
import { VTPOfficeModel } from "../office";
import { VTPParkingModel } from "../parking";
import { VTPRetailBuildingModel } from "../retail-building";
import { VTPRetailShopModel } from "../retail-shop";
import { ValuationProcessHouseModel, ValuationProcessLandModel, ValuationProcessOfficeModel, ValuationProcessParkingModel, ValuationProcessRetailBuildingModel, ValuationProcessRetailShopModel, ValuationProcessSpecialPurposeModel, ValuationProcessTargetPropertyRemote, ValuationProcessWareouseModel } from "../target-property";
import { VTPWarehouseModel } from "../warehouse";
import { VTPSpecialPurposeModel } from '../special-purpose'
import { mapVLandAboutProperty } from "./about-property";
import { mapVHouseExternalAspectRemoteToDomain, mapVRetailBuildingExternalAspectRemoteToDomain, mapVWarehouseExternalAspectRemoteToDomain } from "./external-aspect";
import { mapVHouseGroundRemoteToDomain, mapVOfficeGroundRemoteToDomain, mapVRetailBuildingGroundRemoteToDomain, mapVRetailShopGroundRemoteToDomain, mapVWarehouseGroundRemoteToDomain } from "./ground";
import { mapVHouseInternalAspectRemoteToDomain, mapVOfficeInternalAspectRemoteToDomain, mapVRetailBuildingInternalAspectRemoteToDomain, mapVRetailShopInternalAspectRemoteToDomain, mapVWarehouseInternalAspectRemoteToDomain } from "./internal-aspect";
import { mapVParcelIdentificationRemoteToDomain } from "./land-parcel";
import { mapVServiceAndInfraRemoteToDomain } from "./services-and-infra";
import { mapVAssetClassSizeRemoteToDomain, mapVLandSize } from "./size";

export function mapVTPHouseRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessHouseModel): VTPHouseModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: tpRemote.locationData?.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      subTypeCategory: tpRemote.subTypeCategoryName == 'N/A' ? null : tpRemote.subTypeCategoryName,
      subCategory: tpRemote.subCategoryName == 'N/A' ? null : tpRemote.subCategoryName,
      stateOfRepair: tpRemote.aboutProperty.stateOfRepairName,
      handoverStandard: tpRemote.aboutProperty.handoverStandardName,
      aboveFloors: Number(tpRemote.aboutProperty.above_floors),
      belowFloors: Number(tpRemote.aboutProperty.below_floors),
      energyEfficiencyGrade: tpRemote.aboutProperty.energyEfficiencyGradeName,
      generalDescription: tpRemote.aboutProperty.generalDescription,
      constructionDescription: tpRemote.aboutProperty.construction_desc,
      propertyGrade: tpRemote.aboutProperty.property_grade_name,
      completionYear: tpRemote.aboutProperty.completion_year,
      approximateYear: tpRemote.aboutProperty.apprx_year_extended,
      foundationType: tpRemote.aboutProperty.foundation_type_name
    },
    parcelIdentification: mapVParcelIdentificationRemoteToDomain(tpRemote.parcel_identification),
    pictures: tpRemote.pictures,
    internalAspect: mapVHouseInternalAspectRemoteToDomain(tpRemote.internalAspect),
    externalAspect: mapVHouseExternalAspectRemoteToDomain(tpRemote.externalAspect),
    serviceAndInfra: mapVServiceAndInfraRemoteToDomain(tpRemote.service_and_infra),
    ground: mapVHouseGroundRemoteToDomain(tpRemote.ground),
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}

export function mapVTPOfficeRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessOfficeModel): VTPOfficeModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: tpRemote.locationData?.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      subTypeCategory: tpRemote.subTypeCategoryName == 'N/A' ? null : tpRemote.subTypeCategoryName,
      subCategory: tpRemote.subCategoryName == 'N/A' ? null : tpRemote.subCategoryName,
      stateOfRepair: tpRemote.aboutProperty.stateOfRepairName,
      handoverStandard: tpRemote.aboutProperty.handoverStandardName,
      energyEfficiencyGrade: tpRemote.aboutProperty.energyEfficiencyGradeName,
      generalDescription: tpRemote.aboutProperty.generalDescription,
      floors: tpRemote.aboutProperty.floorLocation,
    },
    building: {
      name: tpRemote.buildingInfo.name,
      completionYear: tpRemote.buildingInfo.completionYear,
      buildingType: tpRemote.buildingInfo.buildingType == 'N/A' || tpRemote.buildingInfo.buildingType == null ? null : tpRemote.buildingInfo.buildingType,
      buildingTypeComment: tpRemote.buildingInfo.buildingTypeComment,
      buildingGrade: tpRemote.buildingInfo.buildingGrade == 'N/A' || tpRemote.buildingInfo.buildingGrade == null ? null : tpRemote.buildingInfo.buildingGrade,
      energyEfficiencyGrade: tpRemote.buildingInfo.energyEfficiencyGrade,
      developer: tpRemote.buildingInfo.developer,
      anchorTenant: tpRemote.buildingInfo.anchorTenant,
      foundationType: tpRemote.buildingInfo.foundationType,
      buildingDescription: tpRemote.buildingInfo.buildingDescription,
      pictures: tpRemote.buildingInfo.pictures
    },
    oldBuildingInfo: tpRemote.oldBuildingInfo,
    pictures: tpRemote.pictures,
    internalAspect: mapVOfficeInternalAspectRemoteToDomain(tpRemote.internalAspect),
    ground: mapVOfficeGroundRemoteToDomain(tpRemote.ground),
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}

export function mapVTPParkingRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessParkingModel): VTPParkingModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: tpRemote.locationData?.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      subCategory: tpRemote.subCategoryName == 'N/A' ? null : tpRemote.subCategoryName,
      subTypeCategory: tpRemote.subTypeCategoryName == 'N/A' ? null : tpRemote.subTypeCategoryName,
      stateOfRepair: tpRemote.aboutProperty.stateOfRepairName,
      handoverStandard: tpRemote.aboutProperty.handoverStandardName,
      generalDescription: tpRemote.aboutProperty.generalDescription,
      floors: tpRemote.aboutProperty.floorLocation,
      numberOfUnits: tpRemote.aboutProperty.number_of_units,
      parkingType: tpRemote.aboutProperty.parking_type,
      automation: tpRemote.aboutProperty.automation,
    },
    building: tpRemote.buildingInfo,
    oldBuildingInfo: tpRemote.oldBuildingInfo,
    parcelIdentification: mapVParcelIdentificationRemoteToDomain(tpRemote.parcel_identification),
    pictures: tpRemote.pictures,
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}
export function mapVTPRetailBuildingRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessRetailBuildingModel): VTPRetailBuildingModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: tpRemote.locationData?.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      subTypeCategory: tpRemote.subTypeCategoryName == 'N/A' ? null : tpRemote.subTypeCategoryName,
      subCategory: tpRemote.subCategoryName == 'N/A' ? null : tpRemote.subCategoryName,
      stateOfRepair: tpRemote.aboutProperty.stateOfRepairName,
      handoverStandard: tpRemote.aboutProperty.handoverStandardName,
      aboveFloors: Number(tpRemote.aboutProperty.above_floors),
      belowFloors: Number(tpRemote.aboutProperty.below_floors),
      energyEfficiencyGrade: tpRemote.aboutProperty.energyEfficiencyGradeName,
      generalDescription: tpRemote.aboutProperty.generalDescription,
      constructionDescription: tpRemote.aboutProperty.construction_desc,
      propertyGrade: tpRemote.aboutProperty.property_grade_name,
      completionYear: tpRemote.aboutProperty.completion_year,
      approximateYear: tpRemote.aboutProperty.apprx_year_extended,
      foundationType: tpRemote.aboutProperty.foundation_type_name
    },
    parcelIdentification: mapVParcelIdentificationRemoteToDomain(tpRemote.parcel_identification),
    pictures: tpRemote.pictures,
    internalAspect: mapVRetailBuildingInternalAspectRemoteToDomain(tpRemote.internalAspect),
    externalAspect: mapVRetailBuildingExternalAspectRemoteToDomain(tpRemote.externalAspect),
    ground: mapVRetailBuildingGroundRemoteToDomain(tpRemote.ground),
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}

export function mapVTPRetailShopRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessRetailShopModel): VTPRetailShopModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: generalInfo.locationData.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      subTypeCategory: tpRemote.subTypeCategoryName == 'N/A' ? null : tpRemote.subTypeCategoryName,
      subCategory: tpRemote.subCategoryName == 'N/A' ? null : tpRemote.subCategoryName,
      stateOfRepair: tpRemote.aboutProperty.stateOfRepairName,
      handoverStandard: tpRemote.aboutProperty.handoverStandardName,
      generalDescription: tpRemote.aboutProperty.generalDescription,
      floors: tpRemote.aboutProperty.floorLocation,
    },
    internalAspect: mapVRetailShopInternalAspectRemoteToDomain(tpRemote.internalAspect),
    ground: mapVRetailShopGroundRemoteToDomain(tpRemote.ground),
    building: {
      name: tpRemote.buildingInfo.name,
      completionYear: tpRemote.buildingInfo.completionYear,
      buildingType: tpRemote.buildingInfo.buildingType == 'N/A' || tpRemote.buildingInfo.buildingType == null ? null : tpRemote.buildingInfo.buildingType,
      buildingTypeComment: tpRemote.buildingInfo.buildingTypeComment,
      buildingGrade: tpRemote.buildingInfo.buildingGrade == 'N/A' || tpRemote.buildingInfo.buildingGrade == null ? null : tpRemote.buildingInfo.buildingGrade,
      energyEfficiencyGrade: tpRemote.buildingInfo.energyEfficiencyGrade,
      developer: tpRemote.buildingInfo.developer,
      anchorTenant: tpRemote.buildingInfo.anchorTenant,
      foundationType: tpRemote.buildingInfo.foundationType,
      buildingDescription: tpRemote.buildingInfo.buildingDescription,
      pictures: tpRemote.buildingInfo.pictures
    },
    oldBuildingInfo: tpRemote.oldBuildingInfo,
    pictures: tpRemote.pictures,
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}

export function mapVTPWarehouseRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessWareouseModel): VTPWarehouseModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: tpRemote.locationData?.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      subTypeCategory: tpRemote.subTypeCategoryName == 'N/A' ? null : tpRemote.subTypeCategoryName,
      subCategory: tpRemote.subCategoryName == 'N/A' ? null : tpRemote.subCategoryName,
      stateOfRepair: tpRemote.aboutProperty.stateOfRepairName,
      handoverStandard: tpRemote.aboutProperty.handoverStandardName,
      aboveFloors: Number(tpRemote.aboutProperty.above_floors),
      belowFloors: Number(tpRemote.aboutProperty.below_floors),
      energyEfficiencyGrade: tpRemote.aboutProperty.energyEfficiencyGradeName,
      generalDescription: tpRemote.aboutProperty.generalDescription,
      constructionDescription: tpRemote.aboutProperty.construction_desc,
      propertyGrade: tpRemote.aboutProperty.property_grade_name,
      completionYear: tpRemote.aboutProperty.completion_year,
      foundationType: tpRemote.aboutProperty.foundation_type_name
    },
    parcelIdentification: mapVParcelIdentificationRemoteToDomain(tpRemote.parcel_identification),
    pictures: tpRemote.pictures,
    internalAspect: mapVWarehouseInternalAspectRemoteToDomain(tpRemote.internalAspect),
    externalAspect: mapVWarehouseExternalAspectRemoteToDomain(tpRemote.externalAspect),
    ground: mapVWarehouseGroundRemoteToDomain(tpRemote.ground),
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}

export function mapVTPSpecialPurposeRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessSpecialPurposeModel): VTPSpecialPurposeModel {
  return {
    refNum: 'tp',
    propertySubType: generalInfo.propertySubType,
    propertySubTypeName: tpRemote.propertySubTypeName,
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      locationSurrounding: tpRemote.locationSurrounding,
      timezoneOffset: tpRemote.locationData?.timezoneOffset
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },
    property: {
      specialPurposeType: tpRemote.aboutProperty.specialPurposeType
    },
    parcelIdentification: mapVParcelIdentificationRemoteToDomain(tpRemote.parcel_identification),
    pictures: tpRemote.pictures,
    internalAspect: mapVWarehouseInternalAspectRemoteToDomain(tpRemote.internalAspect),
    externalAspect: mapVWarehouseExternalAspectRemoteToDomain(tpRemote.externalAspect),
    ground: mapVWarehouseGroundRemoteToDomain(tpRemote.ground),
    sizes: mapVAssetClassSizeRemoteToDomain(tpRemote.sizes),
    esgIndicator: mapRemoteESGIndicatorToModel(tpRemote.esgIndicator)
  }
}

export function mapVTPLandRemoteToDomain(tpRemote: ValuationProcessTargetPropertyRemote, generalInfo: ValuationProcessLandModel): VTPLandModel {
  const propertyBase: VLandAboutPropertyBase = {
    landParcelName: null,
    coordinateReferencySystem: tpRemote.landParcel.coordinateRefSystem,
    qualityOfSoilDegradation: tpRemote.landParcel.qos_degradation_name,
    comparativeLandUse: tpRemote.landParcel.comparative_land_use_name,
    landCoverType: tpRemote.landParcel.land_cover_type,
    soureOfLandUseClassification: tpRemote.landParcel.sol_use_classification_name,
    otherCharacteristics: tpRemote.landParcel.other_characteristics,
    landUseApproval: tpRemote.landParcel.land_use_approval_implementation
  }
  return {
    refNum: 'tp',
    propertySubType: 'Land',
    locationData: {
      latitude: generalInfo.locationData.latitude,
      longitude: generalInfo.locationData.longitude,
      country: generalInfo.locationData.countryName,
      city: generalInfo.locationData.cityName,
      zipCode: generalInfo.locationData.zipCode,
      address: generalInfo.locationData.address,
      timezoneOffset: generalInfo.locationData.timezoneOffset,
      locationGrade: generalInfo.locationGrade == 'N/A' ? 'Unknown' : generalInfo.locationGrade,
      points: tpRemote.landParcel.lp_path.map(p => ({ lat: Number(p.lat), lng: Number(p.lng) })).filter(p => p.lat != null && p.lng != null)
    },
    inspectionInfo: {
      typeOfInspection: tpRemote.inspectionTypeId,
      inspectionDate: new Date(tpRemote.inspectionDate),
      anyLimitationOrRestriction: tpRemote.anyLimitationsOrRestrictions,
      limitationDescription: tpRemote.limitationDesc
    },

    sizes: mapVLandSize(tpRemote.landParcel.landAreas),
    pictures: tpRemote.pictures,
    propertySubTypeName: tpRemote.propertySubTypeName,
    property: mapVLandAboutProperty(propertyBase, tpRemote.landParcel.building_exists, tpRemote.landParcel.buildings)
  }
}